import { loadAndShowModal } from "./modal";

document.addEventListener('DOMContentLoaded', function () {
    const shareWithFriendsButtons = document.getElementsByClassName('js-shareWithFriends');


    for (let i = 0; i < shareWithFriendsButtons.length; i++) {
        const shareWithFriendsButton = shareWithFriendsButtons[i];
        const vin = shareWithFriendsButton.getAttribute('data-att');

        shareWithFriendsButton.addEventListener('click', async function () {
            await loadAndShowModal('share_with_friends', {
                size: 'modal-lg',
                queryParams: { vin },
                onLoad: initializeShareWithFriendsModal
            });
        });
    }
});

function initializeShareWithFriendsModal() {
    if (!document.getElementById("linkedin-script")) {
        const script = document.createElement('script');
        script.src = "https://platform.linkedin.com/in.js";
        script.type = "text/javascript";
        script.async = true;
        script.id = "linkedin-script";
        script.innerHTML = "lang: en_US";
        document.body.appendChild(script);
    }
}
